import React, {useEffect, useState} from 'react';
import {Button, Confirm, Divider, Grid, Header, Icon, Input, Item, Modal} from 'semantic-ui-react';
import 'semantic-ui-css/semantic.min.css';
import {useDispatch, useSelector} from 'react-redux';
import {
    createTipoCalendario,
    deleteTipoCalendario,
    fetchTiposCalendarios,
    updateTipoCalendario
} from '../../redux/actions/CountriesActions/TipoCalendarioActions';
import Functions from '../Global/Functions';


export default function TipoCalendario() {
    const [nombre, setNombre] = useState('');
    const [confirmDelete, setConfirmDelete] = useState(false);
    const [modal, setModal] = useState(false);
    const [selected, setSelected] = useState('');
    const tiposCalendarios = useSelector(state => state.tipos_calendarios.tipos_calendarios);
    const loading = useSelector(state => state.tipos_calendarios.loading);
    const country = useSelector(state => state.countries.country);
    const token = useSelector(state => state.root.token);
    const dispatch = useDispatch();
    const save = () => {
        if (nombre) {
            let fd = JSON.stringify({
                id_pais: country.id,
                nombre: nombre.toUpperCase()
            });
            dispatch(createTipoCalendario(token, country.id, fd));
            setNombre('');
        } else {
            Functions.alertWarning();
        }
    };
    const edit = () => {
        if (nombre) {
            let fd = JSON.stringify({
                nombre: nombre.toUpperCase()
            });
            dispatch(updateTipoCalendario(token, country.id, fd, selected.id));
            setNombre('');
            setModal(false);
        } else {
            Functions.alertWarning();
        }
    };
    const tiposCalendariosRendered = tiposCalendarios.map(it =>
        (<Item key={it.id}>
            <Item.Content verticalAlign='middle'>
                <Item.Header>{it.nombre}</Item.Header>
                <Item.Extra floated='right'>
                    <Button size='mini' content='Borrar' icon='delete' labelPosition='left' onClick={() => {
                        setSelected(it);
                        setConfirmDelete(true);
                    }}/>
                    <Button
                        size='mini'
                        content='Editar'
                        icon='edit'
                        labelPosition='right'
                        onClick={() => {
                            setSelected(it);
                            setNombre(it.nombre);
                            setModal(true);
                        }}/>
                </Item.Extra>
            </Item.Content>
        </Item>)
    );

    useEffect(() => {
        async function asd() {
            await dispatch(fetchTiposCalendarios(token, country.id));
        }

        asd();
    }, [country]);

    return (
        <Grid className='no-margin' style={{width: '100%'}}>
            {/*<=<●>=><=<●>=><=<●>=> Confirmar Borrado <=<●>=><=<●>=><=<●>=>*/}
            <Confirm
                open={confirmDelete}
                content='¿Está seguro que quiere eliminar este tipo de materia?'
                cancelButton={<Button color='red' icon='close' content='Cancelar' inverted/>}
                confirmButton={<Button color='green' icon='checkmark' content='Si, eliminar'/>}
                onCancel={() => setConfirmDelete(false)}
                onConfirm={() => [dispatch(deleteTipoCalendario(token, country.id, selected.id)), setConfirmDelete(false)]}
            />

            <Modal size='tiny' open={modal}>
                <Modal.Header>Editando: {selected.nombre}</Modal.Header>
                <Modal.Content scrolling>
                    <Modal.Description>
                        <Grid centered className='no-margin'>
                            <Grid.Row
                                centered
                                className='no-margin scroll1'
                                stretched
                                verticalAlign='middle'>
                                <Grid.Column
                                    computer={16}
                                    mobile={16}
                                    tablet={16}
                                    textAlign='center'>
                                    <label className='truncate subtitle'>Ingrese un nombre</label>
                                    <Input
                                        fluid
                                        onChange={(e) => setNombre(e.target.value)}
                                        placeholder='Nombre del tipo de materia'
                                        size={'large'}
                                        className='uppercase'
                                        value={nombre}/>
                                    <Divider className='divider-5' hidden/>
                                    <Button
                                        fluid
                                        color='teal'
                                        loading={loading}
                                        onClick={edit}
                                        content='Guardar'
                                    />
                                </Grid.Column>
                            </Grid.Row>
                        </Grid>
                    </Modal.Description>
                </Modal.Content>
                <Modal.Actions>
                    <Button color='red' onClick={() => setModal(false)} inverted>
                        <Icon name='close'/> Cerrar
                    </Button>
                </Modal.Actions>
            </Modal>

            <Grid.Row
                stretched
                column={2}
                verticalAlign='top'
                className='no-margin'>
                <Grid.Column
                    computer={8}
                    mobile={16}
                    tablet={8}
                    textAlign='center'>
                    <Header as='h2'>Crear tipo de materia</Header>
                    <Grid centered className='no-margin'>
                        <Grid.Row
                            centered
                            className='no-margin scroll1'
                            stretched
                            verticalAlign='middle'>
                            <Grid.Column
                                computer={16}
                                mobile={16}
                                tablet={16}
                                textAlign='center'>
                                <label className='truncate subtitle'>Ingrese un nombre</label>
                                <Input
                                    fluid
                                    onChange={(e) => setNombre(e.target.value)}
                                    placeholder='Nombre del tipo de materia'
                                    size={'large'}
                                    style={{textTransform: 'uppercase'}}
                                    value={nombre}/>
                                <Divider className='divider-5' hidden/>
                                <Button
                                    fluid
                                    color='teal'
                                    loading={loading}
                                    onClick={save}
                                    content='Guardar'
                                />
                            </Grid.Column>
                        </Grid.Row>
                    </Grid>
                </Grid.Column>

                <Grid.Column
                    computer={8}
                    mobile={16}
                    tablet={8}
                    textAlign='center'>
                    <Header as='h2'>Consultar tipos de calendarios</Header>
                    <Grid.Row
                        stretched
                        className='no-margin scroll1'
                        style={{backgroundColor: '#fff', padding: 10, borderRadius: 10}}>
                        <Item.Group divided relaxed style={{width: '100%'}}>
                            {tiposCalendarios.length !== 0
                                ? loading
                                    ? Functions.loadingMessage()
                                    : tiposCalendariosRendered
                                : loading
                                    ? Functions.loadingMessage()
                                    : Functions.nothingMessage()}
                        </Item.Group>
                    </Grid.Row>
                </Grid.Column>
            </Grid.Row>
        </Grid>);
}
